const getPrivateEventsPageName = (text: string): string =>
  text.split(' | ')[0].trim().replace(/\s+/g, '-').toLowerCase();

export const getPrivateEventsPageNameForHeroCta = (text: string): string =>
  `${getPrivateEventsPageName(text)}-hero-cta`;
